module.exports = __webpack_public_path__ + "img/فولدر-کتان.b257d0ca.png";